import { fetchColleagues } from '@front-app/services/UserApi/UserApi';
import { FullUser } from '@front-app/services/UserApi/UserModel';
import {
	computed,
	ref,
	Ref,
	watch,
} from '@vue/composition-api';
import { CurrentUserStore } from './currentUser';
import { UserStore } from './user';

export interface ColleaguesStore {
	colleagues: Ref<FullUser[]>;
}

export const getColleagueStore = (currentUserStore: CurrentUserStore, userStore: UserStore): ColleaguesStore => {
	const {
		currentUser,
		isLoggedIn,
	} = currentUserStore;
	const colleagueIds: Ref<string[]> = ref([]);
	const fetch = async () => {
		const allColleagueData = await fetchColleagues();
		userStore.setFullUsers(allColleagueData);
		colleagueIds.value = allColleagueData.map(({ id }) => id);
	};
	const reset = async () => {
		colleagueIds.value = [];
		if (isLoggedIn.value) {
			await fetch();
		}
	};
	watch(currentUser, (curr, prev) => {
		if (!curr || curr.id !== prev?.id) {
			reset();
		}
	}, { immediate: true });

	const colleagues = computed(() => colleagueIds.value
		.map(userStore.getFullUser)
		.map(({ value }) => value));

	return {
		colleagues,
	};
};
